import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { timer } from 'rxjs';
import { AuthService } from '../auth.service';
import { MetaService } from '../meta.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'cloudigo-loader',
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export default class LoaderComponent {
  router = inject(LocationService);
  meta = inject(MetaService)

  constructor(){
    timer(8000).pipe(takeUntilDestroyed()).subscribe(() => {
      this.router.navigate(['/']);
    });

    if(this.meta.isBrowser){
      const activated = inject(ActivatedRoute);
      const auth = inject(AuthService);

      const { snapshot } = activated;
      const { token, user, redirect } = snapshot.queryParams;
      if(token){
  
        const fullUrl = redirect ? decodeURIComponent(redirect) : '/';
  
        const [ urlWithQueryParams, ...fragment ] = fullUrl.split('#');
        const [ url, ...queryParams ] = urlWithQueryParams.split('?');
  
        const fullPath = {
          route: url,
          queryParams: Object.fromEntries(new URLSearchParams(queryParams.join('?'))),
          fragment: fragment.join('#')
        };
        
        sessionStorage.setItem('redirect', JSON.stringify(fullPath));
  
        this.router.replace('/loading');
  
        auth.login({
          token,
          user
        }, 'login').catch(e => {});
      }
    }

  }
}
